import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "custom-module-area"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  key: 0,
  class: "back-top-area"
};
var _hoisted_4 = ["src"];
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useLess } from '@/models/hooks';
import { jumpInteractionType } from '@/utils/common';
import { px2vw } from '@/utils/phoneConfig';
export default {
  __name: 'FloatingWindow',
  props: ['floatingData', 'offsetTop', 'scrollRef', 'isFloatingWindowBottom'],
  setup(__props) {
    useLess('views/landingPage/floatingWindow/FloatingWindow.less');
    var store = useStore();
    var router = useRouter();
    var loginTooltipHeight = computed(() => {
      var _store$state$common$l, _store$state$common;
      return (_store$state$common$l = (_store$state$common = store.state.common) === null || _store$state$common === void 0 ? void 0 : _store$state$common.loginTooltipHeight) !== null && _store$state$common$l !== void 0 ? _store$state$common$l : 0;
    });
    var tabbarHeight = computed(() => {
      var _store$state$common$t, _store$state$common2;
      return (_store$state$common$t = (_store$state$common2 = store.state.common) === null || _store$state$common2 === void 0 ? void 0 : _store$state$common2.tabbarHeight) !== null && _store$state$common$t !== void 0 ? _store$state$common$t : 0;
    });
    var jumpToWidgetSecondaryPage = customModuleInfo => {
      jumpInteractionType(customModuleInfo, router);
    };
    return (_ctx, _cache) => {
      var _props$floatingData$, _props$floatingData$2;
      var _component_back_top = _resolveComponent("back-top");
      return _openBlock(), _createElementBlock("div", {
        class: "floating-window-wrapper",
        style: _normalizeStyle({
          marginBottom: loginTooltipHeight.value + tabbarHeight.value + 'px'
        })
      }, [(_props$floatingData$ = __props.floatingData.customModuleInfo) !== null && _props$floatingData$ !== void 0 && _props$floatingData$.pic && (_props$floatingData$2 = __props.floatingData.customModuleInfo) !== null && _props$floatingData$2 !== void 0 && _props$floatingData$2.isShow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: __props.floatingData.customModuleInfo.pic,
        alt: "",
        onClick: _cache[0] || (_cache[0] = $event => jumpToWidgetSecondaryPage(__props.floatingData.customModuleInfo))
      }, null, 8, _hoisted_2)])) : _createCommentVNode("", true), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => {
          var _props$floatingData, _props$floatingData2;
          return [(_props$floatingData = __props.floatingData) !== null && _props$floatingData !== void 0 && _props$floatingData.topShow && (_props$floatingData2 = __props.floatingData) !== null && _props$floatingData2 !== void 0 && _props$floatingData2.topPic ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_back_top, {
            offsetTop: __props.offsetTop,
            scrollRef: __props.scrollRef,
            bottom: _unref(px2vw)(12),
            right: _unref(px2vw)(12),
            class: _normalizeClass({
              'gateway-back-top-box': true,
              'floating-window-bottom-wrapper': __props.isFloatingWindowBottom
            }),
            style: _normalizeStyle({
              marginBottom: loginTooltipHeight.value + tabbarHeight.value + 'px'
            })
          }, {
            content: _withCtx(() => [_createElementVNode("img", {
              src: __props.floatingData.topPic,
              alt: ""
            }, null, 8, _hoisted_4)]),
            _: 1
          }, 8, ["offsetTop", "scrollRef", "bottom", "right", "class", "style"])])) : _createCommentVNode("", true)];
        }),
        _: 1
      })], 4);
    };
  }
};